import { useEffect } from "react";
import { useMoralis } from "react-moralis";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Account from "components/Account";
import Chains from "components/Chains";
import TokenPrice from "components/TokenPrice";
import ERC20Balance from "components/ERC20Balance";
import ERC20Transfers from "components/ERC20Transfers";
import InchDex from "components/InchDex";
//import NFTBalance from "components/LockConfig";
import LockConfig from 'components/LockConfig'
import MintNFTs from "components/MintNFTs";
import Wallet from "components/Wallet";
import { Layout, Tabs } from "antd";
import "antd/dist/antd.css";
import NativeBalance from "components/NativeBalance";
import "./style.css";
import QuickStart from "components/QuickStart";
import Contract from "components/Contract/Contract";
import Text from "antd/lib/typography/Text";
import Ramper from "components/Ramper";
import MenuItems from "./components/MenuItems";
import NFTTokenIds from "components/MintNFTs";
import TestPage from "pages/TestPage";
import { HeartFilled } from "@ant-design/icons";


const { Header, Footer } = Layout;

const styles = {
  content: {
    display: "flex",
    justifyContent: "center",
    fontFamily: "Roboto, sans-serif",
    color: "#041836",
    marginTop: "130px",
    padding: "10px",
  },
  header: {
    position: "fixed",
    zIndex: 1,
    width: "100%",
    background: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Roboto, sans-serif",
    borderBottom: "2px solid rgba(0, 0, 0, 0.06)",
    padding: "0 10px",
    boxShadow: "0 1px 10px rgb(151 164 175 / 10%)",
  },
  headerRight: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    fontSize: "15px",
    fontWeight: "600",
  },
};
const App = ({ isServerInfo }) => {
  const { isWeb3Enabled, enableWeb3, isAuthenticated, isWeb3EnableLoading } = useMoralis();

  useEffect(() => {
    if (isAuthenticated && !isWeb3Enabled && !isWeb3EnableLoading) enableWeb3();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isWeb3Enabled]);

  return (
    <Layout style={{ height: "100vh", overflow: "auto" }}>
      <Router>
        <Header style={styles.header}>
          <img src="/unlock.png" alt="unlock-logo" style={{width: "60px", height: "38px"}}/>
          <MenuItems />
          <div style={styles.headerRight}>
            <Chains />
           
            <NativeBalance />
            <Account />
          </div>
        </Header>

        <div style={styles.content}>
          <Switch>
            <Route exact path="/">
              <LockConfig />
            </Route>
            <Route exact path="/lockConfigure">
              <LockConfig />
            </Route>
            <Route exact path="/mintNFT">
              <MintNFTs />
            </Route>
            <Route path="/testing">
               <TestPage />
            </Route>
            <Route path="/nonauthenticated">
              <>Please login using the "Authenticate" button</>
            </Route>
          </Switch>
         {/*<Redirect to="/nftBalance" />*/} 
        </div>
      </Router>
      <Footer style={{ textAlign: "center" }}>
        <Text style={{ display: "block" }}>
         <p style={{fontSize: "20px", textTransform: "capitalize"}}>made with <HeartFilled style={{fontSize: "27px", color: "red"}}/> by <a href="https://twitter.com/KabuguAbdul" target="_blank" rel="noopener noreferrer">Abdul Kabugu</a> </p>
         <p style={{textTransform: "capitalize"}}>find me on twitter at   <a href="https://twitter.com/KabuguAbdul" target="_blank" rel="noopener noreferrer">Abdul Kabugu</a></p>
         </Text>
      </Footer>
    </Layout>
  );
};



export default App;
